<template>
  <div
    class="modal fade"
    id="freeOfferDetailsDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SFO100 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="panel panel-default table-responsive">
            <div id="surveyFreeOfferDetailsTable">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO101 }}</td>
                    <td style="width: 60%">{{ freeOffer.SurveyTitle }}</td>
                  </tr>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO102 }}</td>
                    <td style="width: 60%">
                      {{ freeOffer.LocationName }}
                      <span v-if="freeOffer.LocationFree"
                        >({{ lang.SFO117 }})</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO110 }}</td>
                    <td style="width: 60%">{{ freeOffer.LocationAddress }}</td>
                  </tr>
                  <tr v-if="freeOffer.Distance">
                    <td style="width: 40%">{{ lang.SFO116 }}</td>
                    <td style="width: 60%">
                      {{ freeOffer.Distance.toFixed(1) }} km
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO114 }}</td>
                    <td style="width: 60%">{{ freeOffer.ScenarioName }}</td>
                  </tr>
                  <tr v-if="freeOffer.SurveyInstanceInfo">
                    <td style="width: 40%">{{ lang.SFO115 }}</td>
                    <td style="width: 60%">
                      {{ freeOffer.SurveyInstanceInfo }}
                    </td>
                  </tr>
                  <tr v-if="freeOffer.LocationAdditionalInfo">
                    <td style="width: 40%">{{ lang.SFO113 }}</td>
                    <td
                      style="width: 60%"
                      v-html="freeOffer.LocationAdditionalInfo"
                    ></td>
                  </tr>
                  <tr v-if="freeOffer.PurchaseMoney">
                    <td style="width: 40%">{{ lang.SFO111 }}</td>
                    <td style="width: 60%">
                      {{
                        globals.getCurrencyString(
                          freeOffer.PurchaseMoney,
                          "EUR"
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO103 }}</td>
                    <td style="width: 60%">
                      {{
                        globals.getCurrencyString(freeOffer.TotalPayment, "EUR")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO107 }}</td>
                    <td style="width: 60%">
                      <a
                        @click="
                          downloadwithFileName(
                            freeOffer.AGBDownloadId,
                            'Free_offer_AGB'
                          )
                        "
                        >AGB</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 40%">{{ lang.SFO106 }}</td>
                    <td style="width: 60%">
                      <a
                        @click="
                          downloadwithFileName(
                            freeOffer.DSGVODownloadId,
                            'Free_offer_DSG'
                          )
                        "
                        >DSGVO</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="panel panel-default"
            id="surveyInstanceDescriptionPanel"
            v-if="freeOffer.SurveyInstanceDescription"
          >
            <div v-html="freeOffer.SurveyInstanceDescription"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.SFO109 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-success"
            @click="acceptFreeOffer()"
          >
            {{ lang.SFO108 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FreeOfferDetailsDialog",
  props: {
    showDialog: { type: Boolean, default: false },
    freeOffer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lang: {
        SFO100: "Free offer",
        SFO101: "Project",
        SFO102: "Location",
        SFO103: "Total Payment",
        SFO104: "Accept free offer failed",
        SFO105: "Info Text",
        SFO106: "DSGVO",
        SFO107: "AGB",
        SFO108: "Accept",
        SFO109: "Cancel",
        SFO110: "Location Address",
        SFO111: "Others",
        SFO112: "Free Offer Accepted",
        SFO113: "Informations",
        SFO114: "Scenario",
        SFO115: "Check Info",
        SFO116: "Distance",
        SFO117: "Location free",
        G00025: "File download failed",
      },
    };
  },
  watch: {
    showDialog(newVal) {
      newVal
        ? this.openFreeOfferDetailsDialog()
        : this.closeFreeOfferDetailsDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#freeOfferDetailsDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
  },
  methods: {
    async downloadwithFileName(guid, name) {
      try {
        await this.globals.downloadFilewithName(guid, name);
      }
      catch(error)
      {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00025, colorOrange: false});
      }
    },
    openFreeOfferDetailsDialog() {
      $("#freeOfferDetailsDialog").modal("show");
    },
    closeFreeOfferDetailsDialog() {
      $("#freeOfferDetailsDialog").modal("hide");
    },
    acceptFreeOffer() {
      let queryString = `/shopper-api/FreeOffer/Accept/?SurveyInstanceGuid=${this.freeOffer.SurveyInstanceGuid}`;
      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.$emit("openGlobalErrorDialog", {errorText: data.Error, colorOrange: false});
          } else {
            this.globals.showSuccessSnackbar(this.lang.SFO112);
          }
          this.closeFreeOfferDetailsDialog();
          this.$emit("freeOfferAccepted");
        },
        error: () => {
          console.error("Error on POST in acceptFreeOffer()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SFO104, colorOrange: false});
        },
      });
    },
  },
};
</script>

<style scoped>
#surveyInstanceDescriptionPanel {
  padding: 10px;
}

.btn {
  text-transform: capitalize;
}

@media (max-width: 1000px) {
  @media screen and (max-aspect-ratio: 13/9) {
    #freeOfferDetailsDialog > .modal-dialog {
      width: 100vw;
      margin: 0;
    }

    #freeOfferDetailsDialog > .modal-dialog .modal-footer {
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      background: lightgray;
      z-index: 1000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// FreeOfferDetailsDialog.vue?2cc6081c